// extracted by css-extract-rspack-plugin
export default {"logo":"rQqX5RAIY2BY3lTO","navigation":"AxjIX9Sc0safvPR8"};